import {React} from "react";
import {useSelector} from "react-redux";
import Button from "@mui/material/Button";
import {Box, Chip, CircularProgress, FormControlLabel, Switch, TextField, Typography} from "@mui/material";
import EditProfileIcon from "../../../Assets/images/icons/edit";
import {useNavigate} from "react-router-dom";

const EditFormSwitch = ({label, isEditing, handleGlobalToggle, editedProfile, inputName, inputValue, type, readOnly, icon, showInProfile}) => {


    return (
        <>
            <div style={{
                display: (!showInProfile && !isEditing) ? "none" : "flex"
            }} className={icon ? 'input-row d-flex' : 'input-row d-flex input-row-with-icon'}>


                <Typography className={'input-label'}>
                    {label}
                </Typography>

                {
                    isEditing ?
                        <Box className={'mt-2'}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        sx={{
                                            marginTop: 2
                                        }}
                                        checked={inputValue}
                                        onChange={handleGlobalToggle(inputName)}
                                        color="primary"
                                    />
                                }
                                // label={label}
                            />
                            {/*<Chip*/}
                            {/*    label="Global Setting"*/}
                            {/*    size="small"*/}
                            {/*    variant="outlined"*/}
                            {/*    sx={{ ml: 1, height: 20 }}*/}
                            {/*/>*/}
                        </Box> :
                        <Typography className={'input-label'}>
                            {inputValue ? 'Active' : 'Not Active'}
                        </Typography>
                }

            </div>
        </>
    );
};

export default EditFormSwitch;
